import i18n, { normalizeLanguage } from '../i18n';

const DEFAULT_LANGUAGE = 'es';
const INTL_LOCALE_BY_LANGUAGE = {
  es: 'es-ES',
  en: 'en-US',
};

const CURRENCY_BY_LANGUAGE = {
  es: 'ARS',
  en: 'USD',
};

const toIntlLocale = (language) => {
  const normalized = normalizeLanguage(language || DEFAULT_LANGUAGE);
  return INTL_LOCALE_BY_LANGUAGE[normalized] || INTL_LOCALE_BY_LANGUAGE.es;
};

const getCurrentLanguage = () => normalizeLanguage(i18n.resolvedLanguage || i18n.language || DEFAULT_LANGUAGE);

export const getUserLocale = () => {
  return toIntlLocale(getCurrentLanguage());
};

export const formatCurrency = (
  value,
  {
    locale = getUserLocale(),
    currency = CURRENCY_BY_LANGUAGE[getCurrentLanguage()] || CURRENCY_BY_LANGUAGE.es,
    minimumFractionDigits,
    maximumFractionDigits,
  } = {}
) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return '';
  }

  const options = {
    style: 'currency',
    currency,
  };

  if (typeof minimumFractionDigits === 'number') {
    options.minimumFractionDigits = minimumFractionDigits;
  }

  if (typeof maximumFractionDigits === 'number') {
    options.maximumFractionDigits = maximumFractionDigits;
  }

  return new Intl.NumberFormat(locale, options).format(Number(value));
};

export const formatNumber = (value, { locale = getUserLocale() } = {}) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return '';
  }

  return new Intl.NumberFormat(locale).format(Number(value));
};

const parseBackendDate = (value) => {
  if (!value) return null;
  // Backend sends LocalDateTime as int array: [year, month, day, hour, min, sec, nano]
  if (Array.isArray(value) && value.length >= 3) {
    // JS Date month is 0-indexed; backend sends 1-indexed
    return new Date(value[0], value[1] - 1, value[2], value[3] ?? 0, value[4] ?? 0, value[5] ?? 0);
  }
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

export const formatDate = (
  value,
  {
    locale = getUserLocale(),
    options = { year: 'numeric', month: 'long', day: 'numeric' },
  } = {}
) => {
  const date = parseBackendDate(value);
  if (!date) return '';
  return date.toLocaleDateString(locale, options);
};

export const formatTime = (
  value,
  {
    locale = getUserLocale(),
    options = { hour: '2-digit', minute: '2-digit' },
  } = {}
) => {
  const date = parseBackendDate(value);
  if (!date) return '';
  return date.toLocaleTimeString(locale, options);
};
